import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  headbar_content: {
    height: '100%',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export { useStyles };
